import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full container-xl mx-auto container-lg relative" }
const _hoisted_2 = { class: "w-full p-4 bg-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons" }, "send", -1)

import MessageList from '@/components/messenger/MessageList.vue'
import { useStoreModule, useUser } from '@/mixins'
import { Message, MessageType } from '@/models/message'
import { limit, orderBy } from '@firebase/firestore'
import dayjs from 'dayjs'
import { where } from 'firebase/firestore'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const { currentUser } = useUser()
const conversationId = computed(() => {
  return route.params.conversationId as string
})

let unsubscribe = () => {
  // // console.log('unsibscribg')
}

const { selected: conversation, find: findConversation } =
  useStoreModule('conversations')
const { store: storeMessage, listenChanges: listenMessagesChanges } =
  useStoreModule('messages')
const {
  items: messages,
  loading,
  fetch: fetchMessages
} = useStoreModule('messages')

onMounted(async () => {
  await findConversation(conversationId.value)
  // scrollToBottom()
})
watch(
  () => conversationId.value,
  async () => {
    console.log('cnversaiton id change')
    await findConversation(conversationId.value)
  }
)

onUnmounted(() => {
  unsubscribe()
})
const sending = ref(false)
const scrollToBottom = () => {
  const messageList = document.getElementById('messagesList')
  if (messageList) {
    // // console.log('messagesList', messageList)
    messageList.scrollTo(0, messageList.scrollHeight)
  }
}

// methods
const sendMessage = async (
  values: { text: string },
  { resetForm }: { resetForm: () => void }
) => {
  // // console.log('sending', values)
  const newMessage: Message = {
    text: values.text,
    type: MessageType.SMS,
    date: new Date().getTime(),
    status: 'sended',
    senderId: currentUser.value.id,
    senderImageUrl: currentUser.value.profileImageUrl
  }
  try {
    sending.value = true
    const message = await storeMessage(newMessage)
    sending.value = false
    scrollToBottom()
    resetForm()
  } catch (e) {
    sending.value = false

    console.error(e)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_fr_button = _resolveComponent("fr-button")!
  const _component_vee_form = _resolveComponent("vee-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MessageList, {
      ref: "messagesList",
      messages: _unref(messages)
    }, null, 8, ["messages"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vee_form, {
        class: "w-full flex items-center justify-center",
        onSubmit: sendMessage
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_field, {
            id: "text",
            class: "mr-4",
            rules: "",
            name: "text"
          }),
          _createVNode(_component_fr_button, {
            loading: sending.value,
            flat: "",
            rounded: "",
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})